import Cache from 'root/cache';
import $ from 'jquery';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'survey-schedule-form',

    events: {
        'change input[name="active_type"]'  : 'onChangeActivate',
        'change input[name="has_end_time"]' : 'onToggleEndDate',
        'change .date-start input'          : 'onChangeStartDate',
        'change .date-end input'            : 'onChangeEndDate',
        'click .account-upgrade'            : 'onAccountUpgrade'
    },

    dom_handlers: {
        onChangeActivate: function(e) {
            this.$el.find('.date-start').toggleClass('active', $(e.currentTarget).val() === 'schedule');

            if ($(e.currentTarget).val() === 'schedule') {
                // set default value
                var now_date_str = Util.moment(Util.now().unix(), 'YYYY-MM-DD', false, false);
                // set start time to next 5 minutes
                var now_time_str = Util.moment(Util.now().unix() +  60 * 5, 'HH:mm', false, false);
                this.$el.find('.date-start input[type="date"]').val(now_date_str);
                this.$el.find('.date-start input[type="time"]').val(now_time_str);

                // set min date
                this.$el.find('.date-start input[type="date"]').attr('min', now_date_str);
                // set min date for end date
                this.$el.find('.date-end input[type="date"]').attr('min', now_date_str);

                this.updateInstruction();
            } else {
                this.$el.find('.schedule-instruction[data-val="start"]').empty();
            }
        },
        onToggleEndDate: function(e) {
            var checked = $(e.currentTarget).prop('checked');

            this.$el.find('.date-end').toggleClass('active', checked);
            this.$el.find('.has-end').toggleClass('fade', !checked);
            this.updateSettings();

            if (checked) {
                // set default value +1 day
                var now_date_str = Util.moment(Util.now().unix() + 86400, 'YYYY-MM-DD', false, false);
                var now_time_str = Util.moment(Util.now().unix(), 'HH:mm', false, false);
                this.$el.find('.date-end input[type="date"]').val(now_date_str);
                this.$el.find('.date-end input[type="time"]').val(now_time_str);

                this.updateInstruction();
            } else {
                this.$el.find('.schedule-instruction[data-val="end"]').empty();
            }
        },
        onChangeStartDate: function(e) {
            this.updateSettings();
            this.updateInstruction();
        },
        onChangeEndDate: function(e) {
            this.updateSettings();
            this.updateInstruction();
        },
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    updateSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    updateInstruction: function() {
        var now_date_str = this.$el.find('.date-start input[type="date"]').val();
        var now_time_str = this.$el.find('.date-start input[type="time"]').val();

        var timeStamp = Util.dateStringToTimestamp(`${now_date_str} ${now_time_str}`, 'YYYY-MM-DD HH:mm');
        this.$el.find('.schedule-instruction[data-val="start"]').text('It will be activated on ' + Util.moment(timeStamp, 'DD MMM YYYY h:mm a', false, false));

        if (this.$el.find('input[name="has_end_time"]').prop('checked')) {
            var e_date_str = this.$el.find('.date-end input[type="date"]').val();
            var e_time_str = this.$el.find('.date-end input[type="time"]').val();

            var timeStamp = Util.dateStringToTimestamp(`${e_date_str} ${e_time_str}`, 'YYYY-MM-DD HH:mm');
            this.$el.find('.schedule-instruction[data-val="end"]').text('It will be deactiated on ' + Util.moment(timeStamp, 'DD MMM YYYY h:mm a', false, false));
        }
    },

    getSettings: function() {
        var settings = {
            is_active: true,
            start_time: 0,
            end_time: 0
        };

        // if schedule is selected
        if (this.$el.find('#schedule').prop('checked')) {
            var s_date_str = this.$el.find('.date-start input[type="date"]').val();
            var s_time_str = this.$el.find('.date-start input[type="time"]').val();

            settings.start_time = Util.dateStringToTimestamp(`${s_date_str} ${s_time_str}`, 'YYYY-MM-DD HH:mm');
        }

        if (this.$el.find('input[name="has_end_time"]').prop('checked')) {
            var e_date_str = this.$el.find('.date-end input[type="date"]').val();
            var e_time_str = this.$el.find('.date-end input[type="time"]').val();

            settings.end_time = Util.dateStringToTimestamp(`${e_date_str} ${e_time_str}`, 'YYYY-MM-DD HH:mm');
        }

        // make sure end time is greater than start time
        if (settings.end_time && settings.start_time && settings.end_time <= settings.start_time) {
            settings.end_time = settings.start_time + 60 * 5;
        }

        return settings;
    },

    getData: function() {
        return this.getSettings();
    },

    render: function() {
        var content =
        '<div>' +
            '<p>' +
                'Once activated, it will be available to collect responses, and you are no longer able to change the type of questions.' +
            '</p>' +
            '<div>' +
                '<input id="activate" type="radio" name="active_type" value="activate" checked><label for="activate">Activate now</label>' +
            '</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<input id="schedule" type="radio" name="active_type" value="schedule">' +
                '<label for="schedule">Schedule for later</label>' +
                (Cache.account.hasFeature('survey_schedule') ? '' :
                '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
            '</div>' +
            '<div class="date-start">' +
                '<input type="date" name="survey_start_date" class="solid compact"/>' +
                '<input type="time" name="start_time" class="solid compact">' +
            '</div>' +
            '<div class="schedule-instruction" data-val="start"></div>' +

            (Cache.account.hasFeature('survey_schedule') ?
            '<hr class="medium">' +
            '<div class="end-time">' +
                '<div class="has-end fade">' +
                    '<input id="has_end_time" type="checkbox" name="has_end_time" value="1">' +
                    '<label for="has_end_time">Set a date to stop collecting responses</label>' +
                '</div>' +
                '<div class="date-end">' +
                    '<input type="date" name="survey_end_date" class="solid compact">' +
                    '<input type="time" name="end_time" class="solid compact">' +
                '</div>' +
            '</div>' +
            '<div class="schedule-instruction" data-val="end"></div>' : '') +
        '</div>'

        this.$el.html(content);

        // feature check
        if (!Cache.account.hasFeature('survey_schedule')) {
            this.$el.find('#schedule').prop('disabled', true);
        }

        return this;
    }
});
